<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <material-card
      :title="$t('views.remittanceshistory.remittances_records')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="account_balance"
      v-if="selectedPlan!=null"
    >
      <pbas-data-table
        :dataProvider="provider"
        fileNamePrefix="remittances"
        @itemsChanged="setData($event)"
        :sortBy="'BillingTerm/Name'"
        :sortDescending="true"
        identifier="remittancesTable"
        :exporters="$exporters"
        @error="error=$event"
      ></pbas-data-table>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{$t(message)}}
        <v-btn dark text @click="snackbar = false">{{$t('globals.close')}}</v-btn>
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import RemittancesHeaders from "../headers/Remittances";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";
export default {
  name: "remittances-table",
   components: {
    ErrorHandler
  },
  mixins: [planSetter],
  data() {
    return {
      error: null,
      provider: undefined,
      remittances: [],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: RemittancesHeaders,
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    async loadPlanData() {
        let url = "plans/" + this.selectedPlan.Id + "/remittances";
        let prefilter = "PlanId eq " + this.selectedPlan.Id;
        this.provider = new PbasOData(
          this.$axiosHttp,
          url,
          this.headers
        );
        this.provider.filter = prefilter
    },
    setData(items) {
      this.remittances = items;
    }
  }
};
</script>

<style>
.full-width {
  width: 100%;
}
</style>


